// CollaboratorsTable.jsx
import React from 'react';
import './LabelPersonTable.css';

const LabelPersonTable = ({ columns, data  }) => {
    return (
        <div className="table-container" style={{marginTop:'25px'}}>
            <table className="collaborators-table">
                <thead>
                    <tr>
                        {columns.map(col => (
                            <th key={col.key}>{col.label /* burada boş string olabilir */}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map(col => (
                                <td key={col.key}>
                                    {col.render
                                        ? col.render(row)
                                        : /* fallback */ row[col.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LabelPersonTable;
